<template>
  <v-app class="main-container-max-height">
    <PerfectScrollbar
      ref="refChatGptPS"
      :options="perfectScrollbarOptions"
      class="mv-h-full"
    >
      <div class="text-center mt-10" v-show="isLoading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-container fluid>
        <v-list two-line>
          <v-divider></v-divider>
          <template v-for="item in items">
            <v-list-item :key="item.summary">
              <!-- <v-list-item-avatar>
                <v-img :src="item.avatar"></v-img>
              </v-list-item-avatar> -->

              <v-list-item-content>
                <v-list-item-title v-text="item.summary"></v-list-item-title>
                <v-list-item-subtitle
                  v-text="item.createTime"
                ></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action style="align-self: center">
                <v-list-item-action-text
                  v-text="item.amount"
                ></v-list-item-action-text>
                <!-- <v-list-item-action-text></v-list-item-action-text> -->
                <v-list-item-action-text
                  v-text="item.walletAmount"
                ></v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="item.summary"></v-divider>
          </template>
        </v-list>
      </v-container>
    </PerfectScrollbar>
  </v-app>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
//例如: import <组件名称> from  <组建路径>
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import { wd_getTransactionList } from "@/service/apiWallet.js";
import { getCurrentUserAvatar } from "@/service/wd_service_com.js";

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {
    PerfectScrollbar,
  },
  props: {},
  data() {
    //这里存放数据
    return {
      // Perfect scrollbar options
      perfectScrollbarOptions: {
        maxScrollbarLength: 100,
        wheelPropagation: false,
      },
      isLoading: true,
      sysUserAvatar: require("@/assets/common/icon_no_data.png"),
      items: [],
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {
    getCurrentUserAvatar,
    handleTransactionList(data) {
      data.forEach((element) => {
        let item = element;
        if (item.type === 1) {
          item.amount = "+" + item.amount;
          // item.avatar = this.sysUserAvatar;
        } else {
          item.amount = "-" + item.amount;
          // item.avatar = getCurrentUserAvatar();
        }
        item.walletAmount = `钱包余额：${item.walletAmount}`;
        this.items.push(item);
      });
    },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    let that = this;
    wd_getTransactionList().then(
      (response) => {
        that.isLoading = false;
        if (response.data.code == 200) {
          that.handleTransactionList(response.data.result);
        } else {
          // that.isLoading = false;
          // that.snackbar = true;
          // that.errorDescription = response.data.message;
        }
      },
      (error) => {
        that.isLoading = false;
        that.snackbar = true;
        that.errorDescription = error;
      }
    );
  },
  destroyed() {}, //生命周期-销毁完成
  activated() {}, //如果页面有keep-alive,这函数会触发
};
</script>

<style scoped></style>
